import React, { useState } from 'react'
import { Link } from 'gatsby'

import { HamburgerSpin } from 'react-animated-burgers'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import logoActividad from '../../../assets/images/logo_menu_mb.png'

import './nav-menu.scss'
const LOCALE = process.env.LOCALE;

const NavMenu = ({ isMobile }) => {

  const [isActive, setIsActive] = useState(false)
  const [activeMenu, setActiveMenu] = useState(false)

  const toggleButton = evt => {
    if (evt) {
      let text = evt.target?.innerText;
      if (text) {
        if (text) {
          pushEventData(
            {
              event: 'Menú',
              action: 'click menu',
              label: text
            }
          );
        }
      }
    }

    setIsActive(prevState => !prevState)
    setActiveMenu(prevState => !prevState)
  }

  const menuOptions = () => {
    return (
      <ul className="f-nav-menu__list">
        <li className="f-nav-menu__item">
          <a
            href="#inicio"
            className="f-nav-menu__link"
            onClick={toggleButton}
          >
            <p>Inicio</p>
          </a>
        </li>
        <li className="f-nav-menu__item">
          <a
            href="#participate"
            className="f-nav-menu__link"
            onClick={toggleButton}
          >
            <p>¿Cómo participar?</p>
          </a>
        </li>
        <li className="f-nav-menu__item">
          <Link
            to="game"
            className="f-nav-menu__link"
            onClick={toggleButton}
          >
            <p>Jugar</p>
          </Link>
        </li>
        {LOCALE !== 'es-AR' && <li className="f-nav-menu__item">
          <a
            href="#top-jugadoras"
            className="f-nav-menu__link"
            onClick={toggleButton}
          >
            <p>Top jugadoras</p>
          </a>
        </li>}
        <li className="f-nav-menu__item">
          <a
            href="#terms"
            className="f-nav-menu__link"
            onClick={toggleButton}
          >
            <p>Términos y condiciones</p>
          </a>
        </li>
      </ul>
    )
  }

  return (
    <nav className="f-nav-menu">
      {isMobile ? (
        <>
          <HamburgerSpin
            barColor="#fff"
            className={"f-nav-menu__hamburButtom " + (isActive && '--active')}
            {...{ isActive, toggleButton }}
          />
          {
            //menu mobile
            activeMenu && (
              <div className="f-navMenu-mobile-container">
                <img
                  src={logoActividad}
                  className="f-navMenu-mobile-container__imgLogoMobile"
                  alt="busca palabras actividad logo"
                />
                {menuOptions()}
              </div>
            )
          }
        </>
      ) : (
        menuOptions()
      )}
    </nav>
  )
}

export default NavMenu
